/* ==========================================================================
   Occasion cards -> gallery hero image

   Picking a flavour already swaps the hero frame: the flavour dropdown's
   options carry data-hero and the gallery exposes window.showVariantHero.
   The occasion cards are markup, not a .fd-wrap dropdown, so they never
   reached that path — choosing Gift Box or the Jar left the frame showing
   whatever the flavour had put there.

   This listens on the document in the capture phase for the same reason the
   card->radio bridge in the gallery script does: Dawn replaces the info
   column on every variant change, so a listener bound to the cards
   themselves would die on the first click.
   ========================================================================== */
(function () {
  if (window.__gioPkgCardHero) return;
  window.__gioPkgCardHero = true;

  document.addEventListener(
    'click',
    function (event) {
      var card = event.target && event.target.closest && event.target.closest('.pkg-card');
      if (!card) return;

      var hero = card.getAttribute('data-hero');
      if (!hero) return;

      // The gallery script owns the frame; if it has not booted, do nothing
      // rather than reach into its DOM ourselves.
      if (typeof window.showVariantHero !== 'function') return;

      var label = card.getAttribute('data-hero-label') || card.getAttribute('data-value') || '';
      window.showVariantHero(hero, label);
    },
    true
  );
})();
